// extracted by mini-css-extract-plugin
module.exports = {"root":"_9ca6993","background":"_e9faef3","tournamentName":"_d1c67eb"};